import { render, staticRenderFns } from "./QuickActions.vue?vue&type=template&id=72b2cfe7&scoped=true"
import script from "./QuickActions.vue?vue&type=script&lang=js"
export * from "./QuickActions.vue?vue&type=script&lang=js"
import style0 from "./QuickActions.vue?vue&type=style&index=0&id=72b2cfe7&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72b2cfe7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('72b2cfe7')) {
      api.createRecord('72b2cfe7', component.options)
    } else {
      api.reload('72b2cfe7', component.options)
    }
    module.hot.accept("./QuickActions.vue?vue&type=template&id=72b2cfe7&scoped=true", function () {
      api.rerender('72b2cfe7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/systemSetting/userSetting/union/components/QuickActions.vue"
export default component.exports